import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { StringTableService } from '../../services/string-table.service';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit {

  dialogTypeEnum = dialogTypeEnum;
  isProgressComplete = false;
  ofLabel: string;
  emailsLabel: string;
  autoTestCodeName: string;

  @ViewChild('closeBtn') closeBtn: ElementRef;

  @ViewChild('dialog') dialog: ElementRef;

  @Input() dialogContent: {
    title: string,
    body: string
  };

  @Input() retryPopup = false;

  @Input() progressPopup;
  @Input() dialogType = dialogTypeEnum.default;

  @Input() totalItems;

  @Input() currentEmail;

  @Input() doneItems;

  @Input() validationPopup = false;

  @Output() dialogClosed = new EventEmitter<boolean>();

  constructor(private stringTableService: StringTableService) { }

  ngOnInit() {
    this.dialog.nativeElement.focus();
    console.log(this.progressPopup);
    this.retrieveStrings();
  }
  retrieveStrings() {
    this.ofLabel = this.stringTableService.getString('labels', 'of');
    this.emailsLabel = this.stringTableService.getString('labels', 'emails');
    this.autoTestCodeName = this.stringTableService.getString('labels', 'autoTestCodeName');
  }

  closeDialog(isSuccessCallbackCalled?) {
    if (isSuccessCallbackCalled) {
      this.dialogClosed.emit(isSuccessCallbackCalled);
    } else {
      this.dialogClosed.emit(false);
    }
  }

/**
 * focus on close button after pressing tab on last element else focus itself
 * @param event
 */
  onLastBtnFocus(event: Event) {
    if (this.closeBtn) {
      this.closeBtn.nativeElement.focus();
    } else {
      (event.target as any).focus();
    }
  }

}

export enum dialogTypeEnum {
  default = 0,
  retryPopup = 1,
  validationPopup = 2,
  progressPopup = 3,
  question = 4,
  continueCancel = 5
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/modal-dialog/modal-dialog.component.ts